import { render, staticRenderFns } from "./ManageKnowledge.vue?vue&type=template&id=72edf5eb&"
import script from "./ManageKnowledge.vue?vue&type=script&lang=js&"
export * from "./ManageKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports